import { ClinicTypes } from "../services/types/clinics.type";
import EnumDataSource from "../utils/enum-data-source.util";

export const clinicTypesMapping = {
  [ClinicTypes.FULL_TIME]: "Full time",
  [ClinicTypes.PART_TIME]: "Part time",
  [ClinicTypes.SERVICE_LOCATION]: "Service Location"
};
export const CLINIC_TYPES = new EnumDataSource(clinicTypesMapping);

export const ACTUAL_CLINIC_TYPES = [
  ClinicTypes.FULL_TIME,
  ClinicTypes.PART_TIME
];

export const EDOCS_SORT_NAME_ASC = "name_asc";
export const EDOCS_SORT_NAME_DESC = "name_desc";
export const EDOCS_SORT_DATE_DESC = "date_desc";
export const EDOCS_SORT_DATE_ASC = "date_asc";

export type EdocsSortOption =
  | typeof EDOCS_SORT_NAME_ASC
  | typeof EDOCS_SORT_NAME_DESC
  | typeof EDOCS_SORT_DATE_DESC
  | typeof EDOCS_SORT_DATE_ASC;

export const DEFAULT_EDOCS_SORT_BY: EdocsSortOption = EDOCS_SORT_DATE_DESC;

export const EDOCS_SORT_OPTIONS = [
  { value: EDOCS_SORT_NAME_ASC, label: "By Name (A-Z)" },
  { value: EDOCS_SORT_NAME_DESC, label: "By Name (Z-A)" },
  { value: EDOCS_SORT_DATE_DESC, label: "By Date (Newest First)" },
  { value: EDOCS_SORT_DATE_ASC, label: "By Date (Oldest First)" }
];
